<template>
  <div
    v-if="client"
    class="main-modal main-modal_w796 main-modal_h85vh"
    :class="{
      'empoyee-form_disabled': !$guard('write', 'Clients'),
    }"
  >
    <div class="main-form__header">
      <div class="main-modal__title main-modal__title_flex">
        <p v-if="isUpdate">{{ client.first_name }} {{ client.last_name }}</p>
        <p v-else>{{ $t("listsHeader.createNewClient") }}</p>

        <div class="main-form__actions" v-if="isUpdate">
          <svg
            v-if="$guard('read', 'Chat')"
            @click="openChat(client.id)"
            width="35px"
            height="35px"
            id="open-chat"
            viewBox="-21 -47 682.66669 682"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill="var(--bg-color-green)"
              d="m552.011719-1.332031h-464.023438c-48.515625 0-87.988281 39.464843-87.988281 87.988281v283.972656c0 48.414063 39.300781 87.816406 87.675781 87.988282v128.863281l185.191407-128.863281h279.144531c48.515625 0 87.988281-39.472657 87.988281-87.988282v-283.972656c0-48.523438-39.472656-87.988281-87.988281-87.988281zm50.488281 371.960937c0 27.835938-22.648438 50.488282-50.488281 50.488282h-290.910157l-135.925781 94.585937v-94.585937h-37.1875c-27.839843 0-50.488281-22.652344-50.488281-50.488282v-283.972656c0-27.84375 22.648438-50.488281 50.488281-50.488281h464.023438c27.839843 0 50.488281 22.644531 50.488281 50.488281zm0 0"
            />
            <path
              fill="var(--bg-color-green)"
              d="m171.292969 131.171875h297.414062v37.5h-297.414062zm0 0"
            />
            <path
              fill="var(--bg-color-green)"
              d="m171.292969 211.171875h297.414062v37.5h-297.414062zm0 0"
            />
            <path
              fill="var(--bg-color-green)"
              d="m171.292969 291.171875h297.414062v37.5h-297.414062zm0 0"
            />
          </svg>

          <svg
            width="35px"
            height="35px"
            style="margin-bottom:5px"
            @click="openRequestModal(client)"
          >
            <use xlink:href="/images/svg/symbols.svg#svg-add-work" />
          </svg>
        </div>
      </div>
    </div>

    <div class="main-form__tabs">
      <specialist-tab
        :layout="layout"
        :text="'Hauptinformation'"
        :type="'default'"
        @changeLayout="changeLayout"
      />

      <specialist-tab
        :layout="layout"
        :text="'Aufträge'"
        :type="'reviews'"
        @changeLayout="changeLayout"
        v-if="isUpdate"
      />

      <specialist-tab
        :layout="layout"
        :text="'Dateien'"
        :type="'files'"
        @changeLayout="changeLayout"
        v-if="isUpdate"
      />

      <specialist-tab
        :layout="layout"
        :text="'Geschichte'"
        :type="'history'"
        @changeLayout="changeLayout"
        v-if="isUpdate"
      />
    </div>

    <component :is="layout" :client="client" :isUpdate="isUpdate" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import specialistTab from '@/components/modals/specialist/specialistTab'
import mainView from './view/mainView'
import reviewsView from './view/reviewsView'
import filesView from './view/filesView'
import historyView from './view/historyView'

export default {
    name: 'client-modal',
    components: {
        default: mainView,
        reviews: reviewsView,
        files: filesView,
        history: historyView,
        specialistTab,
    },
    data() {
        return {
            layout: 'default',
        }
    },
    computed: {
        ...mapGetters({
            client: 'clientGetters',
            clientReviews: 'clientReviewsGetters',
            clientModalType: 'clientModalType',
        }),
        isUpdate() {
            return this.clientModalType === 'edit'
        },
    },
    methods: {
        changeLayout(v) {
            this.layout = v
        },

        fetchOrder(id) {
            this.$emit('fetchOrder', id)
        },

        openChat(id) {
            this.$router.push({ name: 'chat', params: { id, type: 'clients' } })
        },
        openCall(id, firstName, lastName, photo, isAudioCall) {
            const user = {
                fullName: `${firstName} ${lastName}`,
                photo,
                id,
                type: 'clients',
                isAnswer: false,
                isAudioCall,
            }
            this.$store.dispatch('showCallModal', user)
        },
        openRequestModal(client) {
            this.$emit('openRequestModal', client)
        },
    },
}
</script>

<style lang="scss" scoped>
// .replace-all {
//   width: 20px;
//   height: 20px;
//   border: 1px solid #444;
//   display: block;

//   &:checked {
//     border: 1px solid red;
//   }
// }

// .client-addresses {
//   width: 100%;
//   overflow-y: auto;
//   height: 215px;
// }

// .client-address {
//   position: relative;
//   width: 95%;
// }

// .master {
//   &-name {
//     border-top: 1px solid lightgrey;
//     margin-top: 20px;
//     padding-top: 10px;
//     margin-bottom: 10px;
//     color: #4d4d4d;
//     font-family: "SFUIDisplay-Regular";
//     font-size: 18px;
//   }

//   &-comments {
//     width: 100%;
//     max-height: 153px;
//     overflow-y: auto;
//   }

//   &-comment {
//     display: flex;
//     padding: 6px 0;
//     width: 100%;

//     &:nth-child(odd) {
//       background-color: #f8f5f5;
//     }

//     &__rate {
//       width: 10%;
//       text-align: center;
//     }

//     &__comments {
//       width: 70%;
//       box-sizing: border-box;
//       padding-left: 5%;
//     }

//     &__price {
//       width: 10%;
//     }

//     &__service {
//       width: 10%;
//     }

//     &__date {
//       width: 11%;
//     }

//     &__link {
//       width: 20%;
//     }

//     &__status {
//       width: 10%;
//     }
//   }
// }

// .tabs {
//   margin-bottom: 30px;

//   .tab {
//     width: 140px;
//     height: 30px;
//     background-color: #fff;
//     font-size: 13px;
//     border: 1px solid lightgrey;
//     padding: 6px 8px;
//     box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
//     cursor: pointer;

//     &:first-child {
//       border-radius: 4px 0 0 4px;
//     }

//     &:last-child {
//       border-radius: 0 4px 4px 0;
//     }

//     &_active {
//       background-color: rgba(97, 66, 45, 0.05);
//       box-shadow: unset;
//     }
//   }
// }
// .empoyee {
//   &-form {
//     overflow: auto;
//     width: calc(885px - 130px);
//     height: 85vh;
//     position: relative;
//     padding: 51px 65px;
//     display: block;

//     // input {
//     //   outline: none;
//     // }

//     &__title {
//       max-width: 80%;

//       p {
//         overflow: hidden;
//         width: 100%;
//         white-space: pre;
//         text-overflow: ellipsis;
//       }
//     }

//     // &_disabled {
//     //   input {
//     //     cursor: not-allowed;
//     //   }
//     // }

//     &__header {
//       width: 100%;
//       display: flex;
//       font-size: 36px;
//       justify-content: space-between;
//       padding-bottom: 42px;

//       p {
//         margin: 0;
//       }
//     }

//     &__close {
//       position: absolute;
//       right: 0;
//       top: 0;

//       svg {
//         width: 40px;
//         height: 40px;
//       }
//     }

//     &__icon {
//       margin-left: 10px;
//     }

//     &__button {
//       &_update {
//         background-color: var(--bg-color-green);
//         width: 156px;
//         height: 45px;
//         text-align: center;
//         color: #fff;
//         border: none;
//         border-radius: 8px;
//         font-size: 16px;
//         cursor: pointer;
//         transition: all 0.6s;
//         &:hover {
//           background-color: #8bc36f;
//         }
//       }
//     }

//     &__actions {
//       display: flex;
//       align-items: center;
//       margin-left: 76px;

//       svg {
//         margin-left: 21px;
//         transition: transform 0.6s;
//       }
//     }

//     &__img {
//       width: 230px;
//       height: 244px;
//       display: block;
//       background-position: center;
//       background-size: cover;

//       // input {
//       //   display: none;
//       // }
//     }

//     &__info {
//       display: flex;
//     }

//     &__left {
//       // min-width: 243px;

//       img {
//         // height: 216px;
//         // object-fit: cover;
//       }
//     }

//     &__link {
//       height: 35px;
//     }

//     &__rating {
//       display: flex;
//       justify-content: center;
//       align-items: flex-end;
//       color: #4d4d4d;
//       font-size: 16px;
//       margin-bottom: 8px;

//       span {
//         font-size: 18px;
//         color: var(--bg-color-green);
//         display: inline-block;
//         margin: 0 6px;
//       }
//     }

//     &__completed {
//       text-align: center;
//       font-size: 16px;
//       color: #4d4d4d;
//       margin: 0;

//       span {
//         color: var(--bg-color-green);
//       }
//     }

//     // form info
//     &__right {
//       width: calc(100% - 30px);
//       display: flex;
//       justify-content: space-between;
//       flex-wrap: wrap;
//       padding-left: 30px;
//       height: 100%;
//     }

//     &__half {
//       width: 48%;
//       margin: 10px 0;
//       height: 60px;

//       // input {
//       //   padding-left: 20px;
//       //   width: calc(100% - 30px);
//       //   color: #4d4d4d;
//       //   height: 45px;

//       //   border-radius: 8px;
//       //   border: 1px solid #e0e0e0;

//       //   color: #444;
//       //   font-size: 16px;
//       // }
//     }

//     &__full {
//       width: 98%;
//       margin: 10px 0;
//       height: 60px;

//       // input {
//       //   padding-left: 20px;
//       //   color: #4d4d4d;
//       //   width: calc(100% - 20px);
//       //   height: 45px;
//       //   color: #444;

//       //   border-radius: 8px;
//       //   border: 1px solid #e0e0e0;
//       //   font-size: 16px;
//       // }
//     }

//     &__service {
//       width: 100%;
//       margin-bottom: 10px;
//     }

//     &__cta {
//       width: 100%;
//       color: #fff;
//       display: flex;
//       justify-content: center;
//       margin-top: 45px;
//       position: absolute;
//       bottom: 30px;
//       left: 0;

//       button,
//       span {
//         display: flex;
//         align-items: center;
//         justify-content: center;
//         width: 156px;
//         height: 45px;
//         color: #fff;
//         border: none;
//         border-radius: 8px;
//         font-size: 16px;
//         margin: 0 32.5px;
//       }

//       &_add,
//       &_cancel {
//         background-color: rgba(97, 66, 45, 1);
//         transition: all 0.5s;
//         cursor: pointer;
//         position: relative;
//         z-index: 9;

//         &:hover {
//           background-color: #fcee21;
//           color: #000000 !important;
//         }
//       }
//     }
//   }
// }
// .disableBtn {
//   background-color: rgba(97, 66, 45, 0.5);
//   z-index: 2;
//   position: relative;

//   &:hover {
//     outline: none;
//     cursor: unset;
//     background-color: rgba(97, 66, 45, 0.5);
//   }
// }
// .schedule {
//   display: flex;
//   justify-content: space-between;
//   margin-top: 10px;

//   &-period {
//     padding-right: 30px;

//     &__datepicker {
//       height: 52px;
//       padding-left: 10px;
//       border-radius: 8px;
//       border: 1px solid #e0e0e0;
//       display: flex;
//       align-items: center;
//       margin: 0 8px;
//       position: relative;

//       &_inactive {
//         &::after {
//           position: absolute;
//           right: 20px;
//           top: 30%;
//           content: "";
//           background-image: url(/images/calendar.png);
//           width: 20px;
//           height: 20px;
//           z-index: 3;
//         }
//       }
//     }

//     &__from-to {
//       display: flex;
//       align-items: center;
//       margin-bottom: 30px;

//       p {
//         font-size: 16px;
//         color: rgba(51, 49, 50, 0.5);
//       }

//       // input {
//       //   height: 50px;
//       //   border-radius: 8px;
//       //   border: 1px solid #e0e0e0;
//       //   color: #444;
//       //   font-size: 16px;
//       //   width: 77px;
//       //   margin: 0 8px;
//       //   padding-left: 15px;
//       // }
//     }

//     &__time {
//       display: flex;
//       align-items: center;
//       p {
//         font-size: 16px;
//         color: rgba(51, 49, 50, 0.5);
//       }

//       // input {
//       //   height: 50px;
//       //   border-radius: 8px;
//       //   border: 1px solid #e0e0e0;
//       //   color: #444;
//       //   font-size: 16px;
//       //   width: 80px;
//       //   margin: 0 8px;
//       //   padding-left: 15px;
//       // }
//     }
//   }

//   &-weeks {
//     &__title {
//       color: #4d4d4d;
//       font-size: 18px;
//     }

//     &__btns {
//       display: flex;

//       span {
//         width: 43px;
//         padding: 17px 0;
//         font-size: 16px;
//         border: 1px solid #e0e0e0;
//         border-radius: 8px;
//         display: inline-block;
//         margin-right: 7px;
//         text-align: center;
//         cursor: pointer;
//       }
//     }
//   }

//   &-week {
//     &_active {
//       background-color: var(--bg-color-green);
//     }
//   }
// }
</style>
<style>
/* .empoyee-form .select2-container--default .select2-selection--single {
  max-width: 100% !important;
  height: 40px !important;
} */
</style>
